export enum EFirestoreCollection {
  ACCOUNTS = 'Accounts',
  TRANSACTIONS = 'Transactions',
  ENTITIES = 'Entities',
  PORTFOLIO_SNAPSHOTS = 'PortfolioSnapshots',
}
